<template>
  <v-dialog v-model="dialog" max-width="560" content-class="edit-op-dialog" @keydown.esc="close">
    <v-card class="eop modal-card">
      <v-btn icon class="close-btn" @click.stop="close"><v-icon>mdi-close</v-icon></v-btn>
      <h2 class="modal-title">Редактировать операцию</h2>

      <div class="price-box">
        <div class="price-col">
          <div class="field-label">Цена:</div>
          <v-text-field
            v-model="priceInput"
            outlined dense hide-details
            class="field"
            type="tel" inputmode="decimal"
            @input="onMask"
          >
            <template #append-outer>
              <span class="unit">₽ / номер</span>
            </template>
          </v-text-field>
        </div>
        <div class="summary-col">
          <div class="field-label">Стоимость операции</div>
          <div class="sum">{{ total | rub }}</div>
        </div>
      </div>

      <v-btn block height="56" class="save-btn mt-7" :disabled="!canSave" @click="onSave">Сохранить</v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EditOpPriceModal',
  props: {
    value: { type: Boolean, required: true },
    op:    { type: Object,  default: () => ({ id:'', numbersCount:0, price:0 }) }
  },
  emits: ['input','save'],
  data(){ return { dialog:false, priceInput: '' } },
  computed:{
    count(){ return Number(this.op?.numbersCount || 0) },
    price(){ return Number((this.priceInput || '').replace(',', '.')) || 0 },
    total(){ return Math.round(this.price * this.count * 100) / 100 },
    canSave(){ return this.count > 0 && this.price >= 0 && Number.isFinite(this.total) }
  },
  watch:{
    value:{ immediate:true, handler(v){ this.dialog = v } },
    dialog(v){ this.$emit('input', v) },
    op:{ immediate:true, deep:true, handler(o){
      const p = Number(o?.price || 0)
      this.priceInput = (Number.isFinite(p) ? String(p) : '0')
    }}
  },
  methods:{
    onMask(v){
      const s = String(v||'').replace(/[^\d.,]/g,'')
      const parts = s.replace(',', '.').split('.')
      if (parts.length > 2) this.priceInput = parts[0] + '.' + parts.slice(1).join('')
      else this.priceInput = s
    },
    onSave(){ this.$emit('save', { price: this.price, total: this.total }); this.dialog=false },
    close(){ this.dialog=false }
  },
  filters:{
    rub(v){ const n=Number(v)||0; try{ return new Intl.NumberFormat('ru-RU').format(n)+' ₽' }catch{ return n+' ₽' } }
  }
}
</script>

<style>
.eop{ --text:#2B2D33; --muted:#808185; --line:#D9DADE; --bg:#F8F8F8; --accent:#4B5EFF; }
.edit-op-dialog{overflow:visible;}
.eop.modal-card{padding:32px 40px 40px;border-radius:8px;}
.eop .modal-title{margin:0 0 24px;font:700 26px/1.3 Manrope,sans-serif;text-align:center;color:var(--text);}
.eop .close-btn{position:absolute;top:20px;right:20px;min-width:32px;height:32px;}
.eop .close-btn .v-icon{font-size:22px;color:#808185;}
.eop .field-label{font:600 13px/1.1 Manrope,sans-serif;color:var(--text);margin-bottom:8px;}
.eop .price-box{background:#fff;border:1px solid var(--line);border-radius:8px;padding:18px 22px;display:flex;justify-content:space-between;align-items:flex-start;}
.eop .price-col{width:240px;}
.eop .field .v-input__slot{min-height:44px;border-radius:8px;border-color:var(--line);}
.eop .field .v-input__slot:hover{border-color:var(--accent)!important;}
.eop .unit{margin-left:8px;color:#6F7075;font:600 14px/1 Manrope,sans-serif;white-space:nowrap;}
.eop .summary-col{text-align:right;}
.eop .sum{font:800 20px/1.3 Manrope,sans-serif;color:var(--text);}
.eop .save-btn {background: var(--accent) !important;color: #fff !important;font: 800 16px/1.2 Manrope, sans-serif;border-radius: 8px;}
</style>
